
export default function Mission() {
  return (
    <section id="mission" className="relative py-12 sm:py-16 lg:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/0652d45dcace66ede12a746a07b08074.jpeg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-6 sm:mb-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4">
            Our Mission & Values
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-yellow-400 mx-auto rounded-full"></div>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white leading-relaxed text-center font-light px-2">
            We believe that golf is about more than just the score—it's about the journey, the camaraderie, and the unforgettable stories created on the world's greatest fairways. Our mission is to bring together golf's most passionate, adventurous spirits and to open the doors to courses that most only dream of playing. Each event is crafted to foster connection, celebrate tradition, and create lifelong memories among friends old and new.
          </p>
        </div>
      </div>
    </section>
  );
}